<template>
  <div>
    <v-text-field
      v-model="model"
      :label="label"
      return-masked-value
      :placeholder="placeholder"
      :rules="required ? [rules.date, rules.required] : [rules.date]"
      :required="required"
      :box="!solo && !std"
      :solo="solo && !std"
      mask="date"
      clearable
      :disabled="disabled"
      :error-messages="error"
      @blur="focused = false"
      @focus="focused = true"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    // must not be arrow functions.
    // the name getter
    name() {
      return this.label;
    },
    // the value getter
    value() {
      return this.value; // `this` is the component instance, `value` is the prop we added.
    },
  },
  props: {
    value: {
      type: String,
    },
    label: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'DD/MM/AAAA',
    },
    error: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    solo: {
      type: Boolean,
      default: false,
    },
    std: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: null,
      focused: false,
      rules: {
        date: value => {
          const pattern1 = /^(([0][1-9]|[1-2][0-9]|[3][0-1])\/(01|03|05|07|08|10|12))\/\d{4}$/; // Months with 31 days
          const pattern2 = /^(([0][1-9]|[1-2][0-9]|30)\/(04|06|05|09|11))\/\d{4}$/; // Months with 30 days
          const pattern3 = /^(([0][1-9]|[1-2][0-8])\/(02))\/\d{4}$/; // Feb with 28 days
          const pattern4 = /^(29\/02)\/\d{2}([02468][048]|[13579][26])$/; // Feb with 29 days in years divisible by 4
          const pattern5 = /^29\/02\/2000$/; // Feb with 29 says in year 2000

          return (
            !value ||
            pattern1.test(value) ||
            pattern2.test(value) ||
            pattern3.test(value) ||
            pattern4.test(value) ||
            pattern5.test(value) ||
            'Formato de fecha no válido'
          );
        },
        required: value => !!value || 'Este campo es obligatorio.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Email inválido';
        },
      },
    };
  },
  mounted() {
    if (this.value) {
      this.model = this.formatFromValueToModel(this.value);
    }
  },
  methods: {
    formatFromValueToModel(value) {
      const split = value.split('-');
      const d = split[2] || null;
      const m = split[1] || null;
      const y = split[0] || null;
      return d && m && y ? `${d}/${m}/${y}` : null;
    },
    formatFromModelToValue(model) {
      const split = model.split('/');
      const d = split[0] || null;
      const m = split[1] || null;
      const y = split[2] || null;
      return d && m && y ? `${y}-${m}-${d}` : null;
    },
  },
  watch: {
    model: {
      handler(val) {
        if (this.focused) {
          this.$emit('input', this.formatFromModelToValue(val));
        }
      },
    },
    value: {
      handler(val) {
        if (!this.focused) {
          if (val) {
            this.model = this.formatFromValueToModel(val);
          }
        }
      },
    },
  },
};
</script>

<style lang="sass" scoped></style>
